<script setup>
  import { useTemplateStore } from '@/stores/template'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'

  // Main store
  const store = useTemplateStore()
  const route = useRoute()

  // Computed property for release notes URL
  const releaseNotesUrl = computed(() => {
    const site = route.params.site || store.site
    return site ? `/${site}/release-notes` : '/release-notes'
  })
</script>

<template>
  <!-- Footer -->
  <footer id="page-footer">
    <slot>
      <div class="bg-body-light">
        <div class="content py-3">
          <div class="row fs-sm">
            <div class="col-sm-6 order-sm-2 py-1 text-center text-sm-end">
              <slot name="content-right"></slot>
            </div>
            <div class="col-sm-6 order-sm-1 py-1 text-center text-sm-start">
              <slot name="content-left">
                <router-link class="fw-semibold" :to="releaseNotesUrl">
                  {{ store.app.name + ' ' + store.app.version }}
                </router-link>
                <label>&nbsp;&copy; {{ store.app.copyright }}</label>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </footer>
  <!-- END Footer -->
</template>

<style scoped>
  .currencyRate span {
    display: block;
  }
</style>
